import React, { Component } from 'react'
import { connect } from "react-redux";
import WebSocketConnection from './Websocket';
import { WS_URL } from '../ConstVariable';
import { useAuth0, withAuth0 } from "@auth0/auth0-react";
import {SetSelectedWorkdeskConversation, setWebSocketFunc, UpdateConversationLog} from '../redux-store/actions';
import { CONNECTION_STATUS, API_URL } from '../ConstVariable';
export default function (ComposedComponent) {

class ConnectionManager extends Component {

  state = {
      ws_connection_status: null,
      internet_connection_status: CONNECTION_STATUS.CONNECTED,
      internet_connection_status_retries:0,
      check_internet_connection_interval_call_id:null,
        ws_connection_ref:null ,
      client_detail:null, 
      interval_time:30,
      number_of_new_calls_since_last_search:0,
      url:`${API_URL}/oi/api/referral/ping`
    }
    
    increment_number_of_new_calls_since_last_search = () =>{
        this.setState({...this.state,
            number_of_new_calls_since_last_search:this.state.number_of_new_calls_since_last_search+1})
    }
    reset_number_of_new_calls_since_last_search = () =>{
        this.setState({...this.state,
            number_of_new_calls_since_last_search:0})
    }
    get_error_code = () =>{
        const {user } = this.props.auth0;
        if(this.state.ws_connection_status === CONNECTION_STATUS.CONNECTED && this.state.internet_connection_status === CONNECTION_STATUS.CONNECTED)
            return {error_code:"", description:"Connected"}
        
        if(this.state.internet_connection_status === CONNECTION_STATUS.DISCONNECTED || this.state.internet_connection_status === CONNECTION_STATUS.CONNECTING)
            return {error_code:"E001", description:"There's a problem connecting with internet. Retrying in "+this.state.interval_time+" seconds..."}
        
        if(this.state.ws_object === null && this.state.ws_connection_status===CONNECTION_STATUS.DISCONNECTED)
            return {error_code:"E002", description:"Lost connection with server. Retrying in "+this.state.interval_time+" seconds..."}

        if(this.state.ws_object === null || this.state.ws_connection_status===CONNECTION_STATUS.CONNECTING)
            return {error_code:"I001", description:"Connecting..."}
        
        if(user?.oi_profile!="customer"){
              return {error_code:"I999", description:"Connecting..."} 
        }else{
            return {error_code:"I999", description:""} 
        }
     
    }
   // Seting the webSocket connection state 
    setWebSocketConnectionStateFunc=(web_socket_ref, webSocketConnectionState)=>{
        let _state = null 
        
        if(webSocketConnectionState===1)
        {
            _state = CONNECTION_STATUS.CONNECTED
        }

        if(webSocketConnectionState===2)
        {
            _state = CONNECTION_STATUS.CONNECTING
        }

        if(webSocketConnectionState===3)
        {
            _state = CONNECTION_STATUS.DISCONNECTED
        }
        console.log("ws_connection_ref:",web_socket_ref)
        this.setState({
            ...this.state,
            ws_connection_status:_state,
            ws_connection_ref:web_socket_ref
        })
    }

    GetAuthToken = async () => {
        const { getAccessTokenSilently } = this.props.auth0;
        const token = await getAccessTokenSilently();
        return token;
      };
    
    
  // Component has mounted now implment initial logic
  componentDidMount = async()=> {
    const { getAccessTokenSilently,user } = this.props.auth0;
    const token = await getAccessTokenSilently();
    
    localStorage.MyToken= token
    const getSelectedConversationId = () => this.props.selectedConversationId;
    
    if(user?.oi_profile!="customer"){
        let ws = new WebSocketConnection(this.setWebSocketConnectionStateFunc,token,this.increment_number_of_new_calls_since_last_search,user,this.props.setSelectedWorkdeskConversation,getSelectedConversationId,this.props.updateConversationLog)
        this.setupInterval(30);
    }
    }

    pingWebSocket=()=>{
        if(this.state.ws_connection_ref===null) return;
        this.state.ws_connection_ref.ping();
    }


   setupInterval(timeout) {
       console.log("Connection manager setting interval:"+timeout+" seconds.")
    let interval_id = setInterval(() => {
        this.check_internet_connection();
    }, timeout*1000);
    this.setState({ ...this.state, check_internet_connection_interval_call_id: interval_id, interval_time:timeout });
}

  check_internet_connection = () =>{
    const getSelectedConversationId = () => this.props.selectedConversationId; 
    const {user } = this.props.auth0;
    // this method should be called from setInterval.
    let headers = {mode: "no-cors", credentials: "include"}
    this.pingWebSocket();
    // let url =`${API_URL}/oi/api/referral/ping`
    fetch(this.state.url, headers).then(res=>{
        if(this.state.internet_connection_status != CONNECTION_STATUS.CONNECTED)
            this.setState({...this.state, internet_connection_status:CONNECTION_STATUS.CONNECTED, internet_connection_status_retries:0})
        
        if(this.state.ws_connection_status === CONNECTION_STATUS.DISCONNECTED){
              
            console.log("Connection manager: Internet connection is UP & websocket connection is in DISCONNECTED state.")
            this.setState(()=>{return {...this.state,ws_connection_status:CONNECTION_STATUS.CONNECTING}})
            let token  = localStorage.getItem("MyToken")
            if(user?.oi_profile!="customer"){
                 let ws = new WebSocketConnection(this.setWebSocketConnectionStateFunc,token,this.increment_number_of_new_calls_since_last_search,user,this.props.setSelectedWorkdeskConversation,getSelectedConversationId,this.props.updateConversationLog)
            }
           
        }
        
    }).catch(err=>{

        if(this.state.internet_connection_status_retries == 0)
        {
            console.log("Connection manager: Event caught!!! Internet connection is DOWN!!!")
            clearInterval(this.state.check_internet_connection_interval_call_id);
            this.setState({...this.state, internet_connection_status:CONNECTION_STATUS.CONNECTING, ws_connection_status: CONNECTION_STATUS.DISCONNECTED,ws_connection_ref:null})
            this.setupInterval(5);

        }
        if(this.state.internet_connection_status_retries == 3)
        {
            console.log("Connection manager: Event caught!!! Internet connection is still DOWN after 3 attempts!!!")
            console.log("Connection manager: Switching to 30 Second retry mode.")
            clearInterval(this.state.check_internet_connection_interval_call_id);
            this.setState({...this.state, internet_connection_status:CONNECTION_STATUS.DISCONNECTED, ws_connection_status: CONNECTION_STATUS.DISCONNECTED,ws_connection_ref:null})

            this.setupInterval(30);
        }
        
        this.setState({...this.state, internet_connection_status_retries:this.state.internet_connection_status_retries+1})
        console.log("Connection manager: Retry attempt#"+this.state.internet_connection_status_retries)

    })
  }


  render() {
    return (
        <div>
          <ComposedComponent {...this.props} web_socket ={this.state.ws_connection_ref} internet_connection_status={this.state.internet_connection_status} ws_connection_status={this.state.ws_connection_status} internet_connection_status_retries={this.state.internet_connection_status_retries} interval_time={this.state.interval_time} get_error_code={this.get_error_code} increment_number_of_new_calls_since_last_search={this.increment_number_of_new_calls_since_last_search} reset_number_of_new_calls_since_last_search={this.reset_number_of_new_calls_since_last_search} number_of_new_calls_since_last_search={this.state.number_of_new_calls_since_last_search}/>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
    return {
        selectedConversationId: state.SelectedConversationId,
    };
};


const mapDispatchToProps =(dispatch)=>{
    return {
        setWebSocketFunc:(ws)=>dispatch(setWebSocketFunc(ws)),
        setSelectedWorkdeskConversation: (data) => dispatch(SetSelectedWorkdeskConversation(data)),
        updateConversationLog: (data) => dispatch(UpdateConversationLog(data))
    }
}

return connect(mapStateToProps,mapDispatchToProps) (withAuth0(ConnectionManager));
}
